export default __webpack_public_path__ + "static/media/granadal2.6bcb125f.png";